// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import type {
  GoogleDetailedPlace,
  SuggestionLocation,
} from '../../../api_types'

/**
 * Transforms a place from Google's API into Mozio's place suggestion object
 * @param  {Object} response The google place
 * @return {Object} A Mozio place object
 * @private
 */
const buildGoogleLocation = (
  response: GoogleDetailedPlace
): SuggestionLocation => {
  const { place_id, types, formatted_address, geometry } = response

  return {
    display: formatted_address,
    place_id,
    value: formatted_address,
    terminal: '',
    type: types[0] === 'airport' ? 'airport' : 'place',
    ...parseLatLng(geometry.location.lat, geometry.location.lng),
  }
}

export default buildGoogleLocation
